import React from "react";
import Slider from "react-slick";

const Carosule = () => {
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    draggable: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="slider-container container me-auto">
      <Slider {...settings}>
        <div className="slide" data-aos="zoom-in" data-aos-duration="1000">
          <div className="slide-content">
            <div className="image-slide">
              <img
                className="w-100 mb-3"
                src="/assets/images/C1.svg"
                alt="carsoule"
              />
            </div>
            <div>{/* <span>September 24, 2023</span> */}</div>
            <h2>Whale-to-Whale Memecoin Transaction</h2>
            <p className="mb-3">
              Facilitate large-scale, private token trades between major holders
              without impacting market prices.
            </p>
            <a target="_blank" href="https://docs.pharmatrades.net/examples-and-use-cases#example-1-whale-to-whale-memecoin-transaction">
              <button>
                Learn More
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.33333 3.5957L14 8.26237M14 8.26237L9.33333 12.929M14 8.26237L2 8.26237"
                    stroke="#0B0B0C"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </a>
          </div>
        </div>
        <div className="slide" data-aos="zoom-in" data-aos-duration="1000">
          <div className="slide-content">
            <div className="image-slide">
              <img
                className="w-100 mb-3"
                src="/assets/images/C2.svg"
                alt="carsoule"
              />
            </div>
            <div>{/* <span>September 24, 2023</span> */}</div>
            <h2>Crypto Project Vesting Tokens to Key Opinion Leaders (KOLs)</h2>
            <p className="mb-3">
              Automate secure token vesting schedules for influencers to ensure
              sustained engagement and partnership.
            </p>
            <a target="_blank" href="https://docs.pharmatrades.net/examples-and-use-cases#example-2-crypto-project-vesting-tokens-to-key-opinion-leaders-kols">
              <button>
                Learn More
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.33333 3.5957L14 8.26237M14 8.26237L9.33333 12.929M14 8.26237L2 8.26237"
                    stroke="#0B0B0C"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </a>
          </div>
        </div>
        <div className="slide" data-aos="zoom-in" data-aos-duration="1000">
          <div className="slide-content">
            <div className="image-slide">
              <img
                className="w-100 mb-3"
                src="/assets/images/C3.svg"
                alt="carsoule"
              />
            </div>
            <div>{/* <span>September 24, 2023</span> */}</div>
            <h2>Private Sale to Early Investors</h2>
            <p className="mb-3">
              Streamline secure and transparent private token sales to early
              investors, enhancing trust and efficiency.
            </p>
            <a target="_blank" href="https://docs.pharmatrades.net/examples-and-use-cases#example-3-private-sale-to-early-investors">
            <button>
              Learn More
              <svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.33333 3.5957L14 8.26237M14 8.26237L9.33333 12.929M14 8.26237L2 8.26237"
                  stroke="#0B0B0C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            </a>

          </div>
        </div>
      </Slider>
    </div>
  );
};

export default Carosule;
